export const mcNotificationHub = {
    labNotificationHub: 'LabNotificationHub'
};




// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/config/constants/mc-notification-hub.consts.ts